(() => {
  window.Shopify = window.Shopify || {};

  if (typeof window.Shopify.formatMoney !== "function") {
    window.Shopify.formatMoney = (cents, format) => {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      const formatString = format || window.Shopify.money_format || "${{amount}}";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = formatString.match(placeholderRegex);

      if (!match) return String(cents);

      const formatWithDelimiters = (number, precision = 2, thousands = ",", decimal = ".") => {
        if (Number.isNaN(number) || number == null) return "0";

        const fixed = (number / 100).toFixed(precision);
        const parts = fixed.split(".");
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      };

      let value = "";
      switch (match[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    };
  }

  window.GRFormatMoney = (cents) => {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return "";
    return window.Shopify.formatMoney(amount, window.Shopify.money_format);
  };
})();
